/** Query param con el código de acceso de un solo uso (ej. `/?acceso=<uuid>`, el que viaja en la push). */
export const LOGIN_LINK_PARAM = 'acceso';

/** Tipo del mensaje que el service worker le manda a la app abierta al tocar una notificación (ver public/sw.js). */
export const PUSH_LINK_MESSAGE = 'psi-push-link';

export interface ParsedPushLink {
  /** Código de acceso de un solo uso, si el link lo trae. */
  code: string | null;
  /** Ruta a la que ir (pathname + query + hash) SIN el código: nunca debe quedar en la URL ni en el historial. */
  path: string;
}

/**
 * Interpreta el link de una notificación. Devuelve `null` si no es de este origen (un push no puede mandar a la
 * psicóloga a otro sitio) o si no es una URL válida.
 */
export function parsePushLink(rawUrl: string, origin: string): ParsedPushLink | null {
  let url: URL;
  try {
    url = new URL(rawUrl, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;

  const raw = url.searchParams.get(LOGIN_LINK_PARAM);
  const code = raw && raw.trim() ? raw.trim() : null;
  url.searchParams.delete(LOGIN_LINK_PARAM);

  return { code, path: `${url.pathname}${url.search}${url.hash}` };
}
